import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import reducers from './reducers';
import thunk from 'redux-thunk';
import { createStore, applyMiddleware } from 'redux';
import { ConfigProvider } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import Root from './Root';
import VConsole from 'vconsole';

let store = createStore(reducers, {}, applyMiddleware(thunk));

window.backendUrl = 'https://devxapi.bjmantis.cn';
if (process.env.Text === 'dev') {
    window.backendUrl = 'https://devxapi.bjmantis.cn';
} else if (process.env.Text === 'qa') {
    window.backendUrl = 'https://qacgateway.bjmantis.net';
} else if (process.env.Text === 'stage') {
    window.backendUrl = 'https://stagecgateway.bjmantis.net';
}else if (process.env.Text === 'prod') {
    window.backendUrl = 'https://cgateway.courseeasy.cn';
}else if (process.env.Text === 'jingtong') {
    window.backendUrl = 'https://jingtongks.bjmantis.net';
}else if (process.env.Text === 'yuzhentang') {
    window.backendUrl = 'https://yuzhentangcgateway.bjmantis.cn';
}

if (process.env.Text !== 'prod' && process.env.Text !== 'jingtong' && process.env.Text !== 'yuzhentang') {
    const vConsole = new VConsole();
}

ReactDOM.render(
    <ConfigProvider locale={zhCN}>
        <Root store={store} />
    </ConfigProvider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
